import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Breadcrumbs, ToastMessage } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';
import { apiService } from 'services/base.service';
import { AddonsType, BrandOption } from 'utils/types';
import SelectBrand from 'components/select-brand';
import { toast } from 'react-toastify';
import { ROUTE_KEYS } from 'utils/constants';
import { SuccessModal } from 'components/base/success-modal';
import SelectMeal from 'components/search-meal';
import SingleBottomNav from 'components/base/single-bottom-nav';

const DuplicateAddonCategory = () => {
  const { addon_id, id, title } = useParams();
  const [selectedBrand, setSelectedBrand] = useState<BrandOption[]>([]);
  const [selectedMeal, setSelectedMeal] = useState<BrandOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [addon, setAddon] = useState({} as AddonsType);

  const fetchAddon = async () => {
    try {
      const res = await apiService.get(`marketing/meal/meal-addons-categories/${id}`, {
        isInternal: true
      });
      const { data } = res.data;
      setAddon(data[0]);
    } catch (err: any) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (id) fetchAddon();
  }, [id]);

  const handleConfirm = async () => {
    setLoading(true);
    const payload = {
      meal_addon_category_id: addon_id,
      meal_ids: selectedMeal?.map((item) => {
        return item.value;
      })
    };
    try {
      await apiService.post('marketing/meal-addon-category-new/duplicate', { data: payload });
      setShowSuccess(true);
    } catch {
      toast(
        <ToastMessage
          type='error'
          message='Error encountered while duplicating meal addon category'
        />
      );
    } finally {
      setLoading(false);
    }
  };

  const breadcrumbs = [
    {
      name: addon.meal?.brand?.name ? `View ${addon.meal?.brand?.name}` : '...',
      path: `${ROUTE_KEYS.MEALS}?brand_id=${addon.meal?.brand?.id}`
    },
    {
      name: addon.meal?.meal_category?.name ?? '...',
      path: `${ROUTE_KEYS.MEALS}/${addon?.meal_category_id}`
    },
    {
      name: 'Addon categories',
      path: `${ROUTE_KEYS.MEALS}/${id}/addon-categories`
    },
    {
      name: 'Duplicate addon category',
      path: ''
    }
  ];

  return (
    <div className='max-w-[755px]'>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <PageHeaderText
        title={`Duplicate ${title}`}
        description='This lets you add an add-on category to various meals'
      />

      <div className='space-y-5 text-[14px]'>
        <div>
          <p className='mb-2 font-medium'>Select brand</p>
          <SelectBrand brands={selectedBrand} setBrands={setSelectedBrand} multiple />
        </div>

        <div>
          <p className=' font-medium'>Select meal</p>
          <SelectMeal
            selectedBrand={selectedBrand}
            selectedMeal={selectedMeal}
            setSelectedMeal={setSelectedMeal}
            multipleBrands
            hasSearch
            multiple
          />
        </div>
      </div>

      <SingleBottomNav
        loading={loading}
        btnDisabled={!selectedBrand || !selectedMeal}
        onConfirm={handleConfirm}
      />
      <SuccessModal onClose={() => setShowSuccess(false)} show={showSuccess}>
        Addon category Successfully Duplicated
      </SuccessModal>
    </div>
  );
};

export default DuplicateAddonCategory;
